import { CheckCircle2, TriangleAlert, WifiOff, HelpCircle, CircleDashed, ShieldCheck, ShieldX } from "lucide-react";

// Paleta técnica — NUNCA coral (#FE6A55). El color siempre acompaña texto + ícono.
const CONFIG = {
  // --- Estados canónicos de SALUD del dispositivo (C2) ---
  confirmado_operativo: {
    label: "Confirmado operativo",
    Icon: ShieldCheck,
    cls: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800",
  },
  confirmado_caido: {
    label: "Confirmado caído",
    Icon: ShieldX,
    cls: "bg-[#9B2C2C]/10 text-[#9B2C2C] border-[#9B2C2C]/30 dark:bg-[#9B2C2C]/30 dark:text-[#F2B8B8] dark:border-[#9B2C2C]/50",
  },
  // --- Estados de DISPLAY del puente ---
  en_linea: {
    label: "En línea",
    Icon: CheckCircle2,
    cls: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800",
  },
  advertencia: {
    label: "Advertencia",
    Icon: TriangleAlert,
    cls: "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800",
  },
  silencioso: {
    label: "Silencioso",
    Icon: WifiOff,
    cls: "bg-[#9B2C2C]/10 text-[#9B2C2C] border-[#9B2C2C]/30 dark:bg-[#9B2C2C]/30 dark:text-[#F2B8B8] dark:border-[#9B2C2C]/50",
  },
  no_confirmable: {
    label: "No confirmable",
    Icon: HelpCircle,
    cls: "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-900/30 dark:text-indigo-300 dark:border-indigo-800",
  },
  sin_datos: {
    label: "Sin datos",
    Icon: CircleDashed,
    cls: "bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-700 dark:text-slate-300 dark:border-slate-600",
  },
};

export default function EstadoBadge({ estado, testId, size = "md" }) {
  const cfg = CONFIG[estado] || CONFIG.sin_datos;
  const { Icon } = cfg;
  const pad = size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm";
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${pad} ${cfg.cls}`}>
      <Icon strokeWidth={2} className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
      {cfg.label}
    </span>
  );
}
